module.exports = __webpack_public_path__ + "static/media/logo.a827efb9.png";